var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-state-town-dialog',{attrs:{"title":_vm._f("i18n")('house.param.town.title'),"subtitle":_vm._f("i18n")('house.param.town.subtitle'),"description":_vm._f("i18n")('house.param.town.description')},model:{value:(_vm.town),callback:function ($$v) {_vm.town=$$v},expression:"town"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-609d936e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/HouseStateTownDialog.vue
// module id = null
// module chunks = 